import { BaseResponse } from './internal/baseresponse';

export class BankBranchResult {
    idx: number;
    sequence: number;
    deposit_branch: string;
    branch_code: string;
    state: boolean;
};

export class BankBranchListResult extends BaseResponse {
  data?: Array<BankBranchResult> = new Array<BankBranchResult>();
}




// WEBPACK FOOTER //
// ./src/app/response/bankbranchresult.ts